<div class="wrapper">
    <div class="overlay" *ngIf="showSpinner">
        <div class="spinner-wrapper align-items-center justify-content-center">
            <app-waitingSpinner></app-waitingSpinner>
        </div>
    </div>
    <div class="block-center mt-4 wd-xl">
        <!-- START card-->
        <div class="middle-box text-center loginscreen animated fadeInDown">
            <div class="card-header text-center bg-transparent" style="padding: 0px; margin-top: 5px; position: relative; text-align: center; left: inherit; border:none">
                <a href="#">
                    <img class="block-center rounded" style="border:none" src="assets/img/logo/AGAT.logo.ShadedNoLeaf.png" alt="AGAT" />
                </a>
            </div>
            <div class="text-center">
                <h5 style="text-align:center;" font-weight-light>
                    Air Quality Monitoring
                </h5>
            </div>
            <br />
            <div class="small font-weight-light text-center">
                <h6 style="text-align:center;">
                    Please login using your existing credentials
                </h6>
            </div>
            <div class="card-body">
                <form name="loginForm"
                      class="form-validate mb-3"
                      [formGroup]="valForm"
                      role="form"
                      novalidate="">
                    <div class="form-group">
                        <div class="input-group with-focus">
                            <input id="idEmail"
                                   #loginUser
                                   formControlName="email"
                                   class="form-control border-right-0"
                                   [(ngModel)]="email"
                                   autocomplete="on"
                                   type="{{ isEmployee ? 'text' : 'email'}}"
                                   placeholder="{{ isEmployee ? 'user name' : 'email'}}"
                                   required=""
                                   autofocus
                                   tabindex="1"
                                   (keydown.arrowup)="onKey($event)"
                                   (keydown.arrowdown)="onKey($event)"
                                   (keydown.tab)="onKey($event)" />
                            <div class="input-group-append">
                                <span class="input-group-text text-muted bg-transparent border-left-0">
                                    <em [className]="isEmployee ? 'fa fa-user' : 'fa fa-envelope'">
                                    </em>
                                </span>
                            </div>
                        </div>
                        <div class="pink-to-red"
                             *ngIf="valForm.controls['email'].hasError('required') && (valForm.controls['email'].dirty || valForm.controls['email'].touched)">
                            This field is required
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="input-group with-focus">
                            <input id="idPassword"
                                   #loginPassword
                                   formControlName="password"
                                   class="form-control border-right-0"
                                   type="password"
                                   [(ngModel)]="password"
                                   placeholder="password"
                                   required=""
                                   tabindex="2"
                                   (keydown.arrowup)="onKey($event)"
                                   (keydown.arrowdown)="onKey($event)"
                                   (keydown.tab)="onKey($event)" />
                            <div class="input-group-append">
                                <span class="input-group-text text-muted bg-transparent border-left-0">
                                    <em id="idLock"
                                        class="fa fa-lock"
                                        (mouseover)="onLockHover()"
                                        (mouseout)="onLockLeave()">
                                    </em>
                                </span>
                            </div>
                        </div>
                        <div class="pink-to-red"
                             *ngIf="valForm.controls['password'].hasError('required') && (valForm.controls['password'].dirty || valForm.controls['password'].touched)">
                            This field is required
                        </div>
                    </div>
                    <button id="idButton"
                            #loginGo
                            class="btn btn-block btn-primary mt-3"
                            tabindex="2"
                            (click)="onLogin()"
                            (keydown.arrowup)="onKey($event)"
                            (keydown.arrowdown)="onKey($event)"
                            (keydown.tab)="onKey($event)">
                        Login
                    </button>
                    <div>
                        <div>
                            <label id="idMessage"
                                   class="pink-to-red">
                                {{ message }}
                            </label>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <!-- END card-->
        <div class="text-center"
             style="margin-bottom:25px;">
            <a href="https://webairold.agatlabs.com/" target="_blank">
                Click here for the old system
            </a>
            <div class="small font-weight-light text-center"
                 style="color: gray;">
                <span>
                    [which will remain available for a short time]
                </span>
            </div>
        </div>
        <div class="small font-weight-light text-center">
            <span>&copy; {{ settings.getAppSetting('copyright') }} {{ settings.getAppSetting('year') }}</span>
            <br />
            <span>{{ settings.getAppSetting('description') }}</span>
        </div>
        <div class="small font-weight-light text-center">
            <span>{{ settings.getAppSetting('version') }}</span>
        </div>
    </div>
</div>
